module.exports = __webpack_public_path__ + "static/media/restart.edf4c121.svg";